<form [formGroup]="tokenForm">
   <div class="header">
      <p>Verifica con tu aplicación</p>
      <img (click)="close()" class="my-auto" height="13" src="assets/icon/x.svg" alt="close">
   </div>

   <div class="body d-flex flex-column">

      <p class="fs-15">Ingresa el código de 6 dígitos generado por tu app de autenticación.</p>

      <mnf-input-form formControlName="token" label="Código" placeholder="654 321"
         [mask]="'000 009 999 99'">
      </mnf-input-form>

      <div class="text-right mt-2">
         <button mat-button (click)="next()">Enviar</button>
      </div>
   </div>
</form>
